import React, { useState, useEffect } from "react";
import {
  Button,
  DateInput,
  FileUploader,
  Input,
  Select,
} from "../../../components/ui";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/solid";
import { useEmployeeContext } from "../../../providers/EditEmployeeProvider";
import useUpload from "../../../hooks/useUpload";
import usePut from "../../../hooks/put/usePut";
import Spinner from "../../../components/loader/Spinner";
import DocumentsDrawer from "./DocumentsDrawer";
import Checkbox from "../../../components/ui/Checkbox";
import { useParams } from "react-router-dom";
import { isObject } from "lodash";
import { dateObjToTimestamp } from "../../../utility";

const WorkDetailsForm = ({
  onNextStep,
  onPreviousStep,
  employmentList,
  shiftList,
  departmentListing,
}) => {
  const { company_employee_id } = useParams();
  const [fileType, setFileType] = useState("");
  const [
    control,
    handleSubmit,
    setValue,
    getValues,
    educationDoc,
    setEducationDoc,
    workDoc,
    setWorkDoc,
  ] = useEmployeeContext();
  const [isJoiningDateGreater, setIsJoiningDateGreater] = useState(false);
  const [isEpfEnabled, setIsEpfEnabled] = useState(false);
  const [isEsiEnabled, setIsEsiEnabled] = useState(false);
  const [employeeCodeError, setEmployeeCodeError] = useState(false);
  const [isEmployeeCodeValid, setIsEmployeeCodeValid] = useState(false);
  const [employeeCodeChecked, setEmployeeCodeChecked] = useState(false);

  const { handleAuth: checkEmployeeCodeMutation } = usePut({
    url: "check_employee_code",
    onSuccess: () => {
      setEmployeeCodeError(false);
      setIsEmployeeCodeValid(true);
      setEmployeeCodeChecked(true);
    },
    onError: () => {
      setEmployeeCodeError(true);
      setIsEmployeeCodeValid(false);
      setEmployeeCodeChecked(true);
    },
  });

  // useEffect(() => {
  //   const epfData = getValues("workDetail.statutory.employeeProvidentFund");
  //   const esiData = getValues("workDetail.statutory.employeeStateIndurance");

  //   if (epfData?.providentFundNumber || epfData?.UAN) {
  //     setIsEpfEnabled(true);
  //     setValue("workDetail.statutory.isEmployeeProvidentFundEnabled", true);
  //   }

  //   if (esiData?.induranceNumber) {
  //     setIsEsiEnabled(true);
  //     setValue("workDetail.statutory.isEmployeeStateInduranceEnabled", true);
  //   }
  // }, []);



  const onSubmit = () => {
    let dateOfJoining = getValues("workDetail.currentWorkDetail.dateOfJoining");
    let probationDate = getValues("workDetail.currentWorkDetail.probationDate");
    const employeeCode = getValues("workDetail.currentWorkDetail.employeeCode");

    if (isObject(dateOfJoining))
      dateOfJoining = dateObjToTimestamp(dateOfJoining);
    if (isObject(probationDate))
      probationDate = dateObjToTimestamp(probationDate);

    if (probationDate && dateOfJoining && dateOfJoining > probationDate) {
      setIsJoiningDateGreater(true);
      return;
    } else if (employeeCode && employeeCodeChecked && !isEmployeeCodeValid) {
      setEmployeeCodeError(true);
      return;
    } else {
      setIsJoiningDateGreater(false);
      setValue(
        "workDetail.previousWorkDetail.educationDocuments",
        educationDoc
      );
      setValue("workDetail.previousWorkDetail.workDocuments", workDoc);
      onNextStep();
    }
  };

  const handleCheckEmployeeCode = () => {
    const employeeCode = getValues("workDetail.currentWorkDetail.employeeCode");
    if (employeeCode) {
      checkEmployeeCodeMutation.mutate({ employeeCode });
    }
  };

  const handleJoiningDateChange = (date) => {
    if (date instanceof Date && !isNaN(date.getTime())) {
      const probationDate = new Date(date);
      probationDate.setMonth(probationDate.getMonth() + 6);
      setValue("workDetail.currentWorkDetail.probationDate", probationDate);
    }
  };

  const upload = useUpload({
    onSuccess: (res) => {
      const files = res.data.data;
      if (fileType === "education") {
        setEducationDoc(files);
      } else {
        setWorkDoc(files);
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const handleGetSelectedFiles = (files, type) => {
    setFileType(type);
    const fileData = {
      files,
      screen: "employee",
    };
    upload.mutate(fileData);
  };
  const [openDrawer, setOpenDrawer] = useState(false);
  const [docType, setDocType] = useState("");
  const handleSetDocumentDataToDrawer = (type) => {
    setOpenDrawer(true);
    setDocType(type);
  };
  const handleRemoveDoc = (imageID) => {
    setEducationDoc([]);
    const array = docType === "education" ? educationDoc : workDoc;
    const index = array.findIndex((item) => item.image_id === imageID);
    if (index !== -1) {
      array.splice(index, 1);
    }
    if (docType === "education") {
      setEducationDoc(array);
    } else {
      setWorkDoc(array);
    }
  };

  const handleEpfChange = (e) => {
    const isChecked = e.target.checked;
    setIsEpfEnabled(isChecked);

    if (!isChecked) {
      // Reset EPF fields when checkbox is unchecked
      setValue("workDetail.statutory.employeeProvidentFund.providentFundNumber", "");
      setValue("workDetail.statutory.employeeProvidentFund.UAN", "");
    }
  };

  const handleEsiChange = (e) => {
    const isChecked = e.target.checked;
    setIsEsiEnabled(isChecked);

    if (!isChecked) {
      // Reset ESI fields when checkbox is unchecked
      setValue("workDetail.statutory.employeeStateIndurance.induranceNumber", "");
    }
  };

  return (
    <>
      <div>
        {upload?.isLoading && <Spinner />}
        <div className=" space-y-8">
          <div>
            <h1 className="font-semibold text-xl mb-6 underline">
              Current Work Details
            </h1>
            <div className="flex gap-6 items-start">
              <div className="flex-1">
                <Input
                  control={control}
                  label={"Designation"}
                  name={"workDetail.currentWorkDetail.designation"}
                  placeholder={"Please enter designation"}
                  rules={{
                    // required: "Designation is required",
                  }}
                />
              </div>
              <div className="w-56">
                <DateInput
                  control={control}
                  label={"Date Of Joining "}
                  name={"workDetail.currentWorkDetail.dateOfJoining"}
                  rules={{
                    required: "Date Of Joining is required",
                  }}
                  onChangeFn={handleJoiningDateChange}
                />
                {isJoiningDateGreater && (
                  <p className="text-red-600 font-medium block text-sm mt-1">
                    Joining date cannot be greater than probation date
                  </p>
                )}
              </div>
              <div className="w-56">
                <DateInput
                  control={control}
                  label={"Probation Date "}
                  name={"workDetail.currentWorkDetail.probationDate"}
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6 items-start mt-6">
              {!company_employee_id && (
                <Select
                  control={control}
                  label={"Department"}
                  name={"workDetail.currentWorkDetail.department"}
                  options={departmentListing}
                  customKey={{
                    label: "departmentName",
                    value: "id",
                  }}
                  rules={{
                    // required: "Department is required",
                  }}
                />
              )}
              {!company_employee_id && (
                <Select
                  control={control}
                  label={"Employment Type"}
                  name={"workDetail.currentWorkDetail.employmentType"}
                  options={employmentList}
                  rules={{
                    // required: "Employment Type is required",
                  }}
                  customKey={{
                    label: "name",
                    value: "id",
                  }}
                />
              )}
              {!company_employee_id && (
                <Select
                  control={control}
                  label={"Shift"}
                  name={"workDetail.currentWorkDetail.shift"}
                  options={shiftList}
                  rules={{
                    // required: false,
                  }}
                  customKey={{
                    label: "shiftName",
                    value: "id",
                  }}
                />
              )}
            </div>

            <div className="flex gap-4 items-end mt-6 mb-14">
              <div className="w-48 relative">
                <Input
                  control={control}
                  label={"Employee Code"}
                  name={"workDetail.currentWorkDetail.employeeCode"}
                  placeholder={"Enter employee code"}
                  rules={{
                    // required: "Employee Code is required",
                  }}
                />
                {employeeCodeError && employeeCodeChecked && (
                  <p className="text-red-600 font-medium text-sm absolute top-full mt-1 left-0">
                    Employee code is already taken
                  </p>
                )}
              </div>
              <Button
                type="button"
                variant="outline"
                onClick={handleCheckEmployeeCode}
                disabled={checkEmployeeCodeMutation.isLoading}
                className="text-sm px-3 py-2 h-10"
              >
                {checkEmployeeCodeMutation.isLoading ? "Checking..." : "Check Code"}
              </Button>
            </div>
          </div>
          <div>
            <h1 className="font-semibold text-xl mb-6 underline">
              Previous Work Details
            </h1>
            <div className=" space-y-6">
              <div className="grid grid-cols-2 gap-6 items-end">
                <Input
                  control={control}
                  label={"Education detail"}
                  name={"workDetail.previousWorkDetail.education"}
                  placeholder={"Please enter education detail"}
                  rules={{
                    // required: "Education detail is required",
                  }}
                />
                {!company_employee_id && (
                  <div className="flex items-center space-x-2">
                    <div className="h-10">
                      <FileUploader
                        multiple
                        accept={".pdf, image/png, image/jpeg, image/jpg"}
                        onChange={(files) =>
                          handleGetSelectedFiles(files, "education")
                        }
                      />
                    </div>
                    {educationDoc?.length > 0 && (
                      <Button
                        variant={"warning"}
                        className=""
                        onClick={() =>
                          handleSetDocumentDataToDrawer("education")
                        }
                      >
                        Documents
                      </Button>
                    )}
                  </div>
                )}
              </div>
              <div className="grid grid-cols-2 gap-6 items-end">
                <Input
                  control={control}
                  label={"Work Experience (in years)"}
                  name={"workDetail.previousWorkDetail.workExperience"}
                  placeholder={"Please enter work experience"}
                  rules={{
                    // required: "Work Experience detail is required",
                  }}
                />
                {!company_employee_id && (
                  <div className="flex items-center space-x-2">
                    <div className="h-10">
                      <FileUploader
                        label="Upload Work Experience Documents"
                        multiple
                        accept={".pdf, image/png, image/jpeg, image/jpg"}
                        onChange={(files) =>
                          handleGetSelectedFiles(files, "work")
                        }
                      />
                    </div>
                    {workDoc?.length > 0 && (
                      <Button
                        variant={"warning"}
                        className=""
                        onClick={() => handleSetDocumentDataToDrawer("work")}
                      >
                        Documents
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="mb-6">
              <h1 className="font-semibold text-xl underline">
                Statutory Components
              </h1>
              {/* <small>
                Enable the necessary benefits and tax applicable for this
                employee.
              </small> */}
            </div>

            <div className="mt-5">
              <p className="mb-4 font-semibold">Employee Provident Fund</p>
              <div className="grid grid-cols-2 gap-6 items-end">
                <Input
                  control={control}
                  label={"PF Account Number:"}
                  name={
                    "workDetail.statutory.employeeProvidentFund.providentFundNumber"
                  }
                  placeholder={"AA/AAA/0000000/000/0000000"}
                  rules={{
                    required: false,
                  }}
                />
                <Input
                  control={control}
                  label={"UAN"}
                  name={"workDetail.statutory.employeeProvidentFund.UAN"}
                  placeholder={"0000"}
                  rules={{
                    required: false,
                  }}
                />
              </div>
            </div>

            <div className="mt-5">
              <p className="mb-4 font-semibold">Employees' State Insurance</p>
              <div className="grid grid-cols-2 gap-6 items-end">
                <Input
                  control={control}
                  label={"ESI Insurance Number:"}
                  name={
                    "workDetail.statutory.employeeStateIndurance.induranceNumber"
                  }
                  placeholder={"0000"}
                  rules={{
                    required: false,
                  }}
                />
              </div>
              <small className="text-xs text-gray-500">
                Note: ESI deductions will be made only if the employee’s
                monthly salary is less than or equal to ₹21,000
              </small>
            </div>
          </div>
{/* <div>
            <div className=" mb-6">
              <h1 className="font-semibold text-xl underline">
                Statutory Components
              </h1>
              <small>
                Enable the necessary benefits and tax applicable for this
                employee.
              </small>
            </div>

            <div className=" mt-5">
              <div className="flex items-center mb-4">
                <Checkbox
                  control={control}
                  name={"workDetail.statutory.isEmployeeProvidentFundEnabled"}
                  label={"Employee Provident Fund"}
                  onChangeFn={handleEpfChange}
                />
              </div>

              {isEpfEnabled && (
                <div className="grid grid-cols-2 gap-6 items-end">
                  <Input
                    control={control}
                    label={"PF Account Number:"}
                    name={
                      "workDetail.statutory.employeeProvidentFund.providentFundNumber"
                    }
                    placeholder={"AA/AAA/0000000/000/0000000"}
                    rules={{
                      // required: false,
                    }}
                  />
                  <Input
                    control={control}
                    label={"UAN"}
                    name={"workDetail.statutory.employeeProvidentFund.UAN"}
                    placeholder={"0000"}
                    rules={{
                      // required: false,
                    }}
                  />
                </div>
              )}
            </div>

            <div className=" mt-5">
              <div className="flex items-center mb-4">
                <Checkbox
                  control={control}
                  name={"workDetail.statutory.isEmployeeStateInduranceEnabled"}
                  label={"Employees' State Insurance"}
                  onChangeFn={handleEsiChange}
                />
              </div>

              {isEsiEnabled && (
                <div className="grid grid-cols-2 gap-6 items-end">
                  <Input
                    control={control}
                    label={"ESI Insurance Number:"}
                    name={
                      "workDetail.statutory.employeeStateIndurance.induranceNumber"
                    }
                    placeholder={"0000"}
                    rules={{
                      // required: false,
                    }}
                  />
                </div>
              )}

              {isEsiEnabled && (
                <small className=" text-xs text-gray-500">
                  Note: ESI deductions will be made only if the employee’s
                  monthly salary is less than or equal to ₹21,000
                </small>
              )}
            </div>

            <div className=" mt-5">
              <Checkbox
                control={control}
                name={"workDetail.statutory.professionalTax"}
                label={"Professional Tax"}
              />
              <small className=" block text-gray-400">{`Note: Professional Tax deductions`}</small>
              <small className=" block text-gray-400">{`Male employee if salary between ₹ 7,500 - ₹ 10,000 - (₹175) will be deducted if salary greater then ₹ 10,000 - (₹200) will be deducted`}</small>
              <small className=" block text-gray-400">{`Female employee if salary between ₹ 7,500 - ₹ 25,000 - (₹0) will be deducted if salary greater then ₹ 25,001 - (₹200) will be deducted`}</small>
            </div>
          </div> */}
        </div>
        <div className="flex justify-center my-10 space-x-3 items-center">
          <Button variant={"outline"} onClick={onPreviousStep}>
            <ArrowLeftIcon className="mr-2 w-4 h-4" />
            Previous
          </Button>
          <Button className="" onClick={handleSubmit(onSubmit)}>
            Next
            <ArrowRightIcon className="w-4 h-4 ml-2" />
          </Button>
        </div>
      </div>
      <DocumentsDrawer
        onRemoveDoc={handleRemoveDoc}
        data={docType === "education" ? educationDoc : workDoc}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      />
    </>
  );
};

export default WorkDetailsForm;
